import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export type DollarStage = "puppy" | "adult";
export interface DollarState {
  stage: DollarStage;
  show_grown: boolean;
  progress: { budget_ok: boolean; movements_months: number; savings_months: number; needed: number; min_moves: number };
}

export const DOLLAR_IMG: Record<DollarStage, { avatar: string; full: string }> = {
  puppy: { avatar: "/dollar/cachorro-avatar.png", full: "/dollar/cachorro-arco.png" },
  adult: { avatar: "/dollar/adulto-avatar.png", full: "/dollar/adulto-arco.png" },
};

export function useDollar() {
  const [state, setState] = useState<DollarState | null>(null);
  const load = useCallback(() => {
    api.get<DollarState>("/mentor/dollar").then((r) => setState(r.data)).catch(() => undefined);
  }, []);
  useEffect(() => { load(); }, [load]);
  return { state, setState, reload: load };
}

export function DollarAvatar({ stage, className = "h-9 w-9" }: { stage: DollarStage; className?: string }) {
  return <img src={DOLLAR_IMG[stage].avatar} alt="Dollar" className={`shrink-0 rounded-full ${className}`} data-testid={`dollar-avatar-${stage}`} />;
}
